var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTransferAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.25,
    height: 24.308,
    viewBox: "0 0 24.25 24.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-transfer-act",
    transform: "translate(0.125 0.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15254",
    "data-name": "Grupo 15254",
    transform: "translate(17622 11342.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wire-transfer",
    d: "M9.622,22.18a.837.837,0,0,1-.837.837H5.436A4.191,4.191,0,0,1,1.25,18.831V7.669A4.191,4.191,0,0,1,5.436,3.483h5.793l-.8-.8A.837.837,0,1,1,11.609,1.5l2.233,2.233a.837.837,0,0,1-.592,1.429H5.436A2.514,2.514,0,0,0,2.924,7.669V18.831a2.514,2.514,0,0,0,2.512,2.512H8.785a.837.837,0,0,1,.837.837Zm11.442-18.7H17.715a.837.837,0,0,0,0,1.674h3.349a2.515,2.515,0,0,1,2.512,2.512V18.831a2.515,2.515,0,0,1-2.512,2.512H13.25a.837.837,0,0,0-.592,1.429L14.891,25a.837.837,0,0,0,1.184-1.184l-.8-.8h5.793a4.191,4.191,0,0,0,4.186-4.186V7.669a4.191,4.191,0,0,0-4.186-4.186ZM13.25,19.669a.837.837,0,0,0,.837-.837v-.7a2.7,2.7,0,0,0,.7-5.253l-2.551-.85a1.028,1.028,0,0,1,.325-2h1.111a1.386,1.386,0,0,1,1.317.95.838.838,0,0,0,1.589-.53,3.057,3.057,0,0,0-2.494-2.061V7.669a.837.837,0,0,0-1.674,0v.7a2.7,2.7,0,0,0-.7,5.253l2.551.85a1.028,1.028,0,0,1-.325,2H12.825a1.388,1.388,0,0,1-1.318-.95.837.837,0,0,0-1.588.53,3.055,3.055,0,0,0,2.494,2.061v.718a.837.837,0,0,0,.837.837Z",
    transform: "translate(-17623.25 -11343.254)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransferAct);
export default __webpack_public_path__ + "static/media/ic-transfer-act.5f22bb6822fb52b778715123e318a55e.svg";
export { ForwardRef as ReactComponent };